var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 7,
    viewBox: "0 0 8 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.68925 6.0543C4.72298 6.02057 4.87035 5.89451 4.99109 5.77645C5.75014 5.0876 6.99303 3.28824 7.37211 2.34728C7.43337 2.20436 7.56209 1.84307 7.57097 1.64955C7.57097 1.46491 7.52836 1.28826 7.44136 1.1196C7.31973 0.908328 7.13191 0.742987 6.90691 0.649118C6.75067 0.589643 6.28547 0.49821 6.27659 0.49821C5.76701 0.404114 4.9396 0.353516 4.0243 0.353516C3.1525 0.353516 2.35794 0.404114 1.84037 0.480456C1.83238 0.489333 1.25443 0.580766 1.05557 0.681963C0.881217 0.768465 0.734151 0.901447 0.6306 1.06624C0.527049 1.23102 0.471039 1.42121 0.46875 1.61582V1.64955C0.477628 1.90166 0.702236 2.43072 0.710226 2.43072C1.09019 3.32197 2.27271 5.07961 3.05751 5.78621C3.05751 5.78621 3.25992 5.98417 3.38599 6.07028C3.56709 6.2061 3.79081 6.27267 4.01542 6.27267C4.26578 6.27267 4.49926 6.19722 4.68925 6.0543Z",
    fill: "#F65454"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDown);
export default __webpack_public_path__ + "static/media/down.8e33800a96cfac6296d7d4dab88a6ff6.svg";
export { ForwardRef as ReactComponent };